import { render } from "./portalStudent.vue?vue&type=template&id=581b79c0&scoped=true"
import script from "./portalStudent.vue?vue&type=script&lang=js"
export * from "./portalStudent.vue?vue&type=script&lang=js"

import "./portalStudent.vue?vue&type=style&index=0&id=581b79c0&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-581b79c0"]])

export default __exports__